import { useEffect, useState } from "react";
import { getHandById, type StoredHand } from "../history/db.js";
import { HandDetailModal } from "./HandDetailModal.js";

interface HandDetailModalLoaderProps {
  id: number;
  names: readonly [string, string];
  onClose: () => void;
}

/** Fetches a stored hand by id and renders its detail modal once loaded. */
export function HandDetailModalLoader({ id, names, onClose }: HandDetailModalLoaderProps) {
  const [stored, setStored] = useState<StoredHand | null>(null);

  useEffect(() => {
    let cancelled = false;
    setStored(null);
    void getHandById(id).then((h) => {
      if (!cancelled) setStored(h ?? null);
    });
    return () => {
      cancelled = true;
    };
  }, [id]);

  if (!stored) {
    return (
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-panel" onClick={(e) => e.stopPropagation()}>
          読み込み中…
        </div>
      </div>
    );
  }

  return (
    <HandDetailModal
      record={stored.record}
      matchId={stored.matchId}
      handIndex={stored.handIndex}
      timestamp={stored.timestamp}
      names={names}
      onClose={onClose}
    />
  );
}
